var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('lazy-display-frozenpanetable-xy',{staticClass:"w-100",staticStyle:{"height":"720px"},attrs:{"nbx":100000,"nby":100000000,"default_width":100,"variable_width_start_pos":_vm.variable_width_start_pos,"variable_widthss":_vm.variable_widths,"default_height":20,"variable_height_start_pos":_vm.variable_height_start_pos,"variable_heights":_vm.variable_heights,"horizontal_header_height":20,"vertical_header_width":100},scopedSlots:_vm._u([{key:"horizontalheader",fn:function(ref){
var nbx = ref.nbx;
var width = ref.width;
return [_c('div',{key:nbx,staticClass:"d-inline-block",style:(width)},[_vm._v(_vm._s(nbx))])]}},{key:"verticalheader",fn:function(ref){
var nby = ref.nby;
var height = ref.height;
return [_c('div',{key:nby,style:(height)},[_vm._v(_vm._s(nby))])]}},{key:"bodycell",fn:function(ref){
var nbx = ref.nbx;
var nby = ref.nby;
var width = ref.width;
var height = ref.height;
return [_c('div',{key:(nbx + "x" + nby),style:(width + height)},[_vm._v("\n      "+_vm._s(nbx)+"x"+_vm._s(nby)+"\n    ")])]}}])})}
var staticRenderFns = []

export { render, staticRenderFns }